package org.christophertwo.cotizador.feature.quote.domain

enum class SaleType {
    MENUDEO,
    MAYOREO,
}

